import createVueApp from '@/common/create_app'

Styxie.Initializers.UsersPasswords = {
  new: async(props) => {
    const { default: PasswordsNew } = await import('@/vue_widgets/users/passwords/new/index.vue')
    createVueApp(PasswordsNew, { props, layout: null })
  },
  edit: async(props) => {
    const { default: PasswordsEdit } = await import('@/vue_widgets/users/passwords/edit/index.vue')
    createVueApp(PasswordsEdit, { props, layout: null })
  }
}
